import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { RouteEntity } from '@core/router/route.entity';
import { UserState } from '@core/user/user.state';


export const authGuard: CanActivateFn = () => {
    const userState: UserState = inject(UserState);
    const router: Router = inject(Router);

    return userState.isAuthorized$.pipe(
        map((isAuthorized: boolean) => {
            if (!isAuthorized) {
                const loginUrl = router.parseUrl(RouteEntity.Root + RouteEntity.SignIn);

                return new RedirectCommand(loginUrl, {
                    skipLocationChange: true,
                });
            }

            return true;
        }),
    );
};
